import React from 'react';
import Pagination from '@components/pagination';
import Select from '@components/select';
import PlainText from 'ati-ui-react/components/PlainText';
import * as styles from './Paging.scss';
import strings from '../../strings';

const Paging = (props) => {
  const {
    pageNumber,
    pagesCount,
    options,
    selectedPageSize,
    handlePageSizeChange,
    handlePageNumberChange,
  } = props;

  const localizedStingsForPagination = {
    of: strings.of,
    previousTip: strings.previousPageTip,
    nextTip: strings.nextPageTip,
    inputTip: strings.inputPageTip,
  };

  const pagingWidth = 72;

  return (
    <div className={styles.paging}>
      <Pagination
        onPageChange={event => handlePageNumberChange(event.selected)}
        initialPage={pageNumber}
        pageCount={pagesCount}
        total
        tooltip
        strings={localizedStingsForPagination}
      />
      <div className={styles.selectBlock}>
        <PlainText
          size="small"
        >
          {strings.participantsPerPage}
        </PlainText>
        <div>
          <Select
            className={styles.select}
            options={options}
            dropdownWidth={{ min: pagingWidth, max: pagingWidth }}
            value={selectedPageSize}
            onChange={handlePageSizeChange}
            valueProperty="value"
            labelProperty="text"
          />
        </div>
      </div>
    </div>
  );
};

export default Paging;
